import { RefreshCw } from "lucide-react";

export function AppUpdateNotification() {
  return (
    <div className="fixed bottom-6 right-6 z-[9999] animate-in slide-in-from-bottom-4 fade-in duration-500 ease-out">
      <div className="relative flex items-center gap-4 overflow-hidden rounded-2xl bg-stone-900 px-5 py-4 pr-4 shadow-2xl shadow-black/20 border border-stone-700/60 max-w-xs">
        {/* Midship orange left accent */}
        <div className="absolute left-0 inset-y-0 w-[3px] bg-[#ef3608]" />

        {/* Icon */}
        <div className="flex-shrink-0 w-8 h-8 rounded-xl flex items-center justify-center bg-[#ef3608]/15">
          <RefreshCw size={15} className="text-[#ef3608]" />
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0 pl-0.5">
          <p className="text-[13px] font-semibold text-white leading-none tracking-tight">
            Midship has been updated
          </p>
          <p className="text-[11.5px] text-stone-400 mt-1.5 leading-tight">
            A new version is ready to load.
          </p>
        </div>

        {/* Refresh button */}
        <button
          onClick={() => window.location.reload()}
          className="flex-shrink-0 flex items-center gap-1.5 text-[12px] font-semibold bg-white text-stone-900 rounded-xl px-3 py-2 hover:bg-stone-100 active:scale-95 transition-all duration-150 cursor-pointer"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
